"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var today = new Date();
var m = today.getMonth();
var y = today.getFullYear();
var dates = {
  /**
   * @function Dates[getTs] - 获取时间戳
   * @param {string | number | object} [time=(new Date()).getTime()] 时间
   * @example
   * import { Dates } from '@zz-biz/utils';
   * Dates.getTs('2019-01-02 23:23:45');
   */
  getTs: function getTs() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();
    var result = new Date().getTime();

    try {
      switch ((0, _typeof2["default"])(time)) {
        case 'string':
          result = Date.parse(new Date(time)) || Date.parse(new Date("".concat(time.replace(/-/g, '/'))));
          break;

        case 'object':
          if (time instanceof Date) {
            result = Date.parse(time);
          }

          break;
      }

      return result;
    } catch (err) {
      console.warn(err);
      return result;
    }
  },

  /**
   * @function Dates[getMonthDays] - 获取今年某月天数
   * @param {number} [currentMonth=当前月]
   * @example
   * import { Dates } from '@zz-biz/utils';
   * Dates.getMonthDays(11);
   */
  getMonthDays: function getMonthDays() {
    var currentMonth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : m;
    var curDate = new Date(y, currentMonth, 1);
    var curMonth = curDate.getMonth();
    curDate.setMonth(curMonth + 1, 0);
    return curDate.getDate();
  },

  /**
   * @function Dates[getStartDay] - 某一天的00:00:00时间戳
   * @param {date} dateObj 某日的时间对象
   * @example
   * import { Dates } from '@zz-biz/utils';
   * Dates.getStartDay();
   */
  getStartDay: function getStartDay(dateObj) {
    try {
      var date = dateObj ? new Date(dateObj) : new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date.getTime();
    } catch (err) {
      console.warn(err);
    }
  },

  /**
   * @function Dates[getEndDay] - 某一天的23:59:59时间戳
   * @param {date} dateObj 某日的时间对象
   * @example
   * import { Dates } from '@zz-biz/utils';
   * Dates.getEndDay();
   * // 前天24点的时间戳
   * Dates.getEndDay((new Date().getTime() - 2 * 24 * 3600 * 1000))
   */
  getEndDay: function getEndDay(dateObj) {
    try {
      var date = dateObj ? new Date(dateObj) : new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date.getTime() + 24 * 60 * 60 * 1000 - 1;
    } catch (err) {
      console.warn(err);
    }
  }
};
var _default = dates;
exports["default"] = _default;